import { Link as LinkS } from 'react-scroll';
import { Link as LinkR } from 'react-router-dom';
import styled from 'styled-components';
import { WINDOW_WIDTH_CHANGE_TO_MOBILE_NAVBAR } from '../../constants/constants';

export const Nav = styled.nav`
  height: 90px;
  margin-top: -90px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.85rem;
  position: sticky;
  top: 0;
  z-index: 10;

  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 90px;
  z-index: 1;
  width: 100%;
  padding: 0 32px;
  max-width: 1200px;
  overflow: visible;
`;

export const NavLogo = styled(LinkR)`
  color: var(--color-cream);
  justify-self: flex-start;
  cursor: pointer;
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  margin-left: 24px;
  font-weight: 700;
  font-family: var(--font-heading);
  letter-spacing: 1px;
  text-decoration: none;
`;

export const NavIcon = styled.img`
  height: 80px;
  width: 80px;
  margin-bottom: 0px;
  cursor: pointer;
  filter: drop-shadow(0 2px 6px rgba(0,0,0,0.4));
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: ${WINDOW_WIDTH_CHANGE_TO_MOBILE_NAVBAR}px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.6rem;
    cursor: pointer;
  }
`;

export const CartIconWrap = styled.div`
  position: relative;
  cursor: pointer;
  margin-left: 16px;
  display: flex;
  align-items: center;
  align-self: center;

  @media screen and (max-width: ${WINDOW_WIDTH_CHANGE_TO_MOBILE_NAVBAR}px) {
    display: none;
  }
`;

export const MobileCartIcon = styled.div`
  display: none;

  @media screen and (max-width: ${WINDOW_WIDTH_CHANGE_TO_MOBILE_NAVBAR}px) {
    display: block;
    position: absolute;
    top: 0;
    right: 90px;
    transform: translateY(75%);
    cursor: pointer;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: -22px;
  gap: 4px;

  @media screen and (max-width: ${WINDOW_WIDTH_CHANGE_TO_MOBILE_NAVBAR}px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  height: 90px;
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;

  @media screen and (max-width: ${WINDOW_WIDTH_CHANGE_TO_MOBILE_NAVBAR}px) {
    display: none;
  }
`;

export const NavLinks = styled(LinkR)`
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  font-size: 0.78rem;
  font-family: var(--font-body);
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 20px;
    left: 1rem;
    right: 1rem;
    height: 2px;
    background: var(--color-gold);
    transform: scaleX(0);
    transition: transform 0.25s ease;
  }

  &:hover::after,
  &.active::after {
    transform: scaleX(1);
  }
`;

export const NavBtnLink = styled.a`
  border-radius: 4px;
  background: var(--color-gold);
  white-space: nowrap;
  padding: 10px 24px;
  color: var(--color-off-white);
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  outline: none;
  border: 2px solid var(--color-gold);
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  text-decoration: none;
  font-family: var(--font-body);

  &:hover {
    background: transparent;
    color: var(--color-gold);
  }
`;

export const NavBtnExternalLink = styled.a`
  border-radius: 4px;
  background: var(--color-gold);
  white-space: nowrap;
  padding: 10px 24px;
  color: var(--color-off-white);
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  outline: none;
  border: 2px solid var(--color-gold);
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  text-decoration: none;
  font-family: var(--font-body);

  &:hover {
    background: transparent;
    color: var(--color-gold);
  }
`;